import React from "react";
import Base from "../core/Base";
import HeaderTitle from "../components/HeaderTitle";

const OurFacilities = () => {
    return (
        <Base>
            <HeaderTitle title='Our Facilities'/>
            <section className="contact-area ptb-100">
                <h2 className='text-center'>Our Facilities</h2>
                <div className='container mt-5 text-center facilities'>
                    <div className='row'>
                        <div className='col-12 col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                    <img src={require('../assets/img/CCTV.jpg')}
                                         alt="cctv-security Sarkarizone-libraryin-agra"/>
                                    <div className='img-overlay'><h2>CCTV SECURITY</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">All your materials like bags, books, helmets, and any other
                                        important thing is totally secured and recorded in our CCTV cameras</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                    <img src={require('../assets/img/24in7.jpg')} alt="Sarkarizone-24in7"/>
                                    <div className='img-overlay'><h2>24*7 AVAILABLE</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">We are available 24*7.
                                        For any inquiry, you can call us from 8:00 am to 8:00 pm.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                    <img src={require('../assets/img/eyes_protection.jpg')}
                                         alt="Sarkarizone-eyes_protection"/>
                                    <div className='img-overlay'><h2>EYES PROTECTING</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">We used good quality of lightning in our library, which
                                        will protect your eyes from the harmful rays of the electrical appliances.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                    <img src={require('../assets/img/best_infrastructure.jpg')}
                                         alt="Sarkarizone-best_infrastructure"/>
                                    <div className='img-overlay'><h2>BEST INFRASTRUCTURE</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">Here you get the best furniture, comfortable chairs for
                                        your comfort, secured electric system.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/books_and_news_paper.jpg')}
                                     className="card-img-top" alt="Sarkarizone-books_and_news_paper"/>
                                    <div className='img-overlay'><h2>BOOKS/ NEWSPAPERS AVAILABLE</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">You can get books, newspapers, and magazines according to
                                        your need in our library.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/saprate_room_for_girl.jpg')}
                                     className="card-img-top" alt="Sarkarizone-saprate_room_for_girl"/>
                                    <div className='img-overlay'><h2>SEPARATE ROOM FOR GIRLS</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">There is a separate room for girls for their security
                                        purpose.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/silence_zone.jpg')}
                                     className="card-img-top" alt="Sarkarizone-silence_zone"/>
                                    <div className='img-overlay'><h2>SILENCE ZONE</h2></div>
                                </div>

                                <div className="card-body">
                                    <p className="card-text">There is no noise in our library, it is fully
                                        pinned drop silence.Here you get study properly without any
                                        mind divert or disturbance.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/internet.jpg')}
                                     className="card-img-top" alt="Sarkarizone-internet"/>
                                <div className='img-overlay'><h2>INTERNET</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">Free Wifi available in our campus area. So that you can
                                        study by using the internet.
                                        Internet Speed UPTO 200MBPS
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/locker.jpg')}
                                     className="card-img-top" alt="Sarkarizone-locker"/>
                                    <div className='img-overlay'><h2>LOCKER FACILITY</h2></div>
                                </div>
                                    <div className="card-body">
                                    <p className="card-text">If you are having important material like bags/books then
                                        you can keep it in our locker. Books are totally safe in our library then you
                                        can
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/parking.jpg')}
                                     className="card-img-top" alt="Sarkarizone-parking"/>
                                    <div className='img-overlay'><h2>PARKING</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">Parking is also available which is under CCTV camera.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/sms_alert.jpg')}
                                     className="card-img-top" alt="Sarkarizone-CCTV"/>
                                    <div className='img-overlay'><h2>SMS ALERT(FEES/ HOLIDAY)</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">You will be alert by messages on your due fees date, any
                                        holiday, or any offer.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/lunch_room.jpg')}
                                     className="card-img-top" alt="Sarkarizone-lunch_room"/>
                                    <div className='img-overlay'><h2>LUNCH ROOM</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">There is another separate room in our library for
                                        lunch.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4  px-5 mb-5 offset-md-2'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/fully_AC.jpg')}
                                     className="card-img-top" alt="Sarkarizone-fully_AC"/>
                                    <div className='img-overlay'><h2>FULLY AIR CONDITIONER</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">We are fully air-conditioned rooms.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='col-md-6 col-lg-4 px-5 mb-5'>
                            <div className="card">
                                <div className="card-header-img">
                                <img src={require('../assets/img/water.jpg')}
                                     className="card-img-top" alt="Sarkarizone-water"/>
                                <div className='img-overlay'><h2>WATER</h2></div>
                                </div>
                                <div className="card-body">
                                    <p className="card-text">RO water is available.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Base>
    );
};

export default OurFacilities;
